import React from "react";
import { useSelector } from "react-redux";

import { CheckoutSteps } from "@utils/enums";

import * as CheckoutCustomerDetailsFormSelectors from "@redux/modules/value/checkout/customerDetails/checkoutCustomerDetailsForm.selectors";
import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

import { useCheckout } from "../useCheckout.hook";

const CheckoutDetailsButton = () => {
    const { t } = useGranite();
    const isLoading = useSelector(
        CheckoutCustomerDetailsFormSelectors.isLoading,
    );

    const { cartLoading } = useCheckout();

    return (
        <Button
            test="checkoutDetailsButton-button-submit"
            color={"secondary"}
            fullWidth={true}
            type={"submit"}
            size={"lg"}
            form={"checkoutCustomerDetails"}
            loading={isLoading || cartLoading}
        >
            {t("checkout.customerDetails.button.submit")}
        </Button>
    );
};

export { CheckoutDetailsButton };
